// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text6x6--wrapper--1KGcd","textWrapper":"Text6x6--textWrapper--1Ic9x","box":"Text6x6--box--1f4LK","box4":"Text6x6--box4--3Qf0x"};